import dateToDateString from "@/app/infrastructures/misc/common-library/DateToDateString";
import moment from "moment";
import { configDates } from "../modules/Date";
import { AccountController } from "@/app/ui/controllers/AccountController";

const formatDateTrackingHistory = (
  date: any,
  timezone: any,
  showTimezone = true,
  international = false
) => {
  const locales = AccountController.accountData.countryCode || "id";
  const formattedDate = new Date(date);

  let utcOffset = "0";
  if (timezone) {
    utcOffset = timezone.replace("GMT+", "+0").replace(":", "");
  }
  let newDate = moment(formattedDate)
    .utcOffset(utcOffset)
    .format("DD MMMM YYYY, HH:mm");
  const labels = configDates(timezone);
  const tzName = labels[locales.toLowerCase()] ?? labels.id ?? "";
  if (tzName) {
    newDate =
      (international
        ? dateToDateString(newDate, false, false, "en")
        : newDate) + ` ${showTimezone ? tzName : ""}`;
  }
  return newDate;
};
export default formatDateTrackingHistory;
